import React, { useState } from "react";

import AppWrap from "wrapper/AppWrap";
import MotionWrap from "wrapper/MotionWrap";
import { client } from "client";
import { emailImg, mobile } from "assets/index";
import "./Footer.scss";
import { useTranslation } from "react-i18next";
const Footer = () => {
  const {t} = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: "contact",
      name: name,
      email: email,
      message: message,
    };

    client
      .create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <h2 className="head-text">{t("section.contact")}</h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={emailImg} alt="email" />
          <a href="mailto:job.tranthien@gmail.com" className="p-text">
            job.tranthien@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={mobile} alt="mobile" />
          <a href="tel: +84 913 184 232" className="p-text">
            +84 913 184 232
          </a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              type="text"
              className="p-text"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={handleChangeInput}
            />
          </div>
          <div className="app__flex">
            <input
              type="email"
              className="p-text"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              type="text"
              onChange={handleChangeInput}
            />
          </div>

          <button type="button" className="p-text" onClick={handleSubmit}>
            {loading ? "Sending" : "Send Message"}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">{t("section.thanks")}</h3>
        </div>
      )}
      <div className="app__flex">
        <div className="copyright">
          <p className="p-text">@2022 Fuze</p>
          <p className="p-text">All rights reserved</p>
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
